import moment from "moment";

import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";
import Login from "@/pages/Dashboard/Pages/Login.vue";
// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";

import Products from "@/pages/Dashboard/Products/products.vue";
import EditProduct from "@/pages/Dashboard/Products/edit.vue";
import ProductArrangements from "@/pages/Dashboard/Products/arrangement.vue"
import Keywords from "@/pages/Dashboard/Keywords.vue"
import Categories from "@/pages/Dashboard/Categories.vue"
import Blogs from "@/pages/Dashboard/Blogs/blogs.vue"
import EditBlog from "@/pages/Dashboard/Blogs/edit.vue";
import BlogArrangements from "@/pages/Dashboard/Blogs/arrangement.vue";

import auth from "@/services/auth";

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  beforeEnter: (to, from, next) => {
    if (!auth.isLoggedIn()) {
      next();
    } else {
      next({ name: "Products" });
    }
  },
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login
    }
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home"
  },
  authPages,
  {
    path: "/",
    component: DashboardLayout,
    beforeEnter: (to, from, next) => {
      next();
      if (auth.isLoggedIn()) {
        var token = auth.getToken();
        var expiresDate = moment(token.ExpiryDate);
        var now = moment();
        var duration = moment.duration(expiresDate.diff(now));
        var hours = duration.asHours();
        if (hours < 24) {
          auth.removeToken();
          next({ path: "/login" });
        } else {
          next();
        }
      } else {
        next({ path: "/login" });
      }
    },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: Dashboard }
      },
      {
        path: "products",
        name: "Products",
        meta: { retainScrollPosition: false },
        components: { default: Products }
      },
      {
        path: "products/arrangement",
        name: "ProductArrangements",
        components: { default: ProductArrangements }
      },
      {
        path: "products/:id",
        name: "EditProduct",
        components: { default: EditProduct }
      },
      {
        path: "blogs",
        name: "Blogs",
        components: { default: Blogs }
      },
      {
        path: "blogs/arrangement",
        name: "BlogArrangements",
        components: { default: BlogArrangements }
      },
      {
        path: "blog/:id",
        name: "EditBlog",
        components: { default: EditBlog }
      },
      {
        path: "keywords",
        name: "Keywords",
        components: { default: Keywords }
      },
      {
        path: "tags",
        name: "Tags",
        components: { default: Categories }
      }
    ]
  }
];

export default routes;
